<template>
  <div class="content  import_new_wrap">
    <div class="top">
      <!-- <p class="t-left font-S14 fontC-4fa1a4" style="padding:20px 0 0 16px" v-show="$route.query.pageTitle">{{$route.query.pageTitle}}</p> -->
      <!-- <el-tabs v-model="activeName" type="card" @edit="handleTabsEdit">
        <el-tab-pane label="医院词典" name="first"></el-tab-pane>
        <el-tab-pane label="医药政策库" name="second"></el-tab-pane>
      </el-tabs> -->
      <!-- tab -->
    <div class="import-tab-box">
      <div
        :class="tabIndex == index ? 'import-tab-list import-tab-active' : 'import-tab-list'"
        v-for="(item, index) in tabList"
        :key="index"
        @click="tabClick(index, item)"
      >
        {{ item.name }}
      </div>
    </div>
    </div>
    <div style="display: flex" >
      <div class="fl back-color-fff borderR6 left-tree-box">
        <el-input size="mini" placeholder="搜索分类" v-model="categoryName" style="width: 80%; margin-top:10px;" @change="getContentCategory()">
        </el-input>
        <el-button icon="el-icon-plus" class="add-btn" @click="addData">添加分类</el-button>
        <!-- <div style="display: flex;" :class="isAllType?'color-grey':''">
          <div class="all-classify"  >全部分类</div> 
          <div class="btn" style="padding-right: 20px;">
            <i class="el-icon-document-checked i-edit-sty" ></i>
            <i class="el-icon-edit-outline i-edit-sty" ></i>
            <i class="el-icon-delete i-sty"></i>
          </div>
        </div> -->
        <el-table
          :data="tagList"
          ref="singleTable"
          highlight-current-row
          :show-header="false"
          @row-click="searchDict"
        >
        <el-table-column prop="categoryName">
            <template slot-scope="scope">
              <div  style="padding-left: 20px;"  >{{ scope.row.categoryName }}</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="right" >
            <template slot-scope="scope">
              <!-- v-if="shbtn[scope.$index]" -->
              <div v-if="scope.$index!=0" class="btn" style="padding-right: 20px;">
                
                <i
                  class="el-icon-edit-outline i-edit-sty"
                  @click.stop="updateHandle(scope.row)"
                ></i>
                <i 
                  class="el-icon-delete i-sty"
                  @click.stop="delContentCategory(scope.row.guid)"
                ></i>
              </div>
            </template>
          </el-table-column>
          
        </el-table>
        <el-pagination
          :current-page="page1.pageIndex"
          :page-size="page1.pageSize"
          layout="prev, pager, next"
          @size-change="handleSizeChange1"
          @current-change="handleCurrentChange1"
          :total="page1.totalRows"
        >
        </el-pagination>
      </div>
  
      <div v-show="tabIndex==0" class="right-content-box">
        <div class="search-area">

          <el-row :gutter="24">
            <el-col :span="6">
              <div class="search-area-div">关键字</div>
              <el-input size="mini" v-model="keywordSearch" placeholder="请输入" class="ipt-sty" />
            </el-col>
            <el-col :span="6">
              <div class="search-area-div">上架状态</div>
              <el-select size="mini" v-model="bizState" placeholder="请选择" class="ipt-sty">
                <el-option v-for="item in status" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="6" class="search-btn-box">
              <el-button size="mini" type="info" @click="searchDict('',true)">搜索</el-button>
              <el-button size="mini" type="danger" @click="emptyDictSearch">清空</el-button>
            </el-col>
          </el-row>
        </div>

        <div class="back-color-fff content-main-box">

          <div class="button-area">
            <el-button  size="mini" type="info" @click="addContent">发布内容</el-button>
            <el-button  size="mini" type="default" @click="changeState(1,multipleSelection,true)">批量上架</el-button>
            <el-button  size="mini" type="default" @click="changeState(2,multipleSelection,true)">批量下架</el-button>
            <el-button  size="mini" type="default" @click="preview()" >移动端效果预览</el-button>
            <el-button  size="mini" type="default" @click="report" v-loading.fullscreen.lock="fullscreenLoading">导出阅读明细</el-button>
          </div>
          <el-table :data="tableData" stripe border :height="tableHeight" style="width: 100%" v-loading="loading" tooltip-effect="light" @selection-change="handleSelectionChange" >
            <el-table-column type="selection" width="40" header-align="center" align="center"
              fixed="left"></el-table-column>
            <el-table-column label="序号" width="50" header-align="center" align="center"  fixed="left">
              <template slot-scope="scope">
                <!-- {{ scope.$index + 1 }} -->
                {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
              </template>
            </el-table-column>

            <el-table-column prop="medicineDictTitle" label="内容标题" header-align="left" align="left" show-overflow-tooltip  width="160" fixed="left">
              <template slot-scope="scope">{{ scope.row.medicineDictTitle }}</template>
            </el-table-column>
            <el-table-column prop="contentType" label="内容分类"  header-align="left" align="left" width="160" show-overflow-tooltip  >
              <template slot-scope="scope" >
                <span v-for="item in scope.row.contentCategoryNames">
                  {{ item}}
                </span>
               
              </template>
            </el-table-column>
            <el-table-column prop="publishDate" label="发布日期" sortable header-align="left" align="left" width="120">
              <template slot-scope="scope">{{ scope.row.publishDate | getDate }}</template>
            </el-table-column>
            <el-table-column prop="readUserNum"  label="阅读人数" header-align="right" align="right" >
              <template slot-scope="scope">{{scope.row.readUserNum | "-"}}</template>
            </el-table-column>

            <el-table-column prop=" readNum" label="阅读次数" header-align="right" align="right">
              <template slot-scope="scope">{{ scope.row.readNum  }}</template>
            </el-table-column>
            <el-table-column prop="bizState" label="状态"  header-align="center" align="center" >
              <template slot-scope="scope">
                
                <span v-show="scope.row.bizState=='1'" class="state-class">上架</span>
                <span v-show="scope.row.bizState=='2'" class="state-class-grey">下架</span>
                
                
              </template>
            </el-table-column>
            <el-table-column prop="updateUserName" label="操作人"  header-align="left" align="left" width="80">
              <template slot-scope="scope">{{ scope.row.updateUserName }}</template>
            </el-table-column>
            <el-table-column prop="updateTime" sortable label="操作时间" header-align="left" align="left" width="150">
              <template slot-scope="scope">{{ scope.row.updateTime | getTimeDate }}</template>
            </el-table-column>
            <el-table-column label="操作" header-align="center" align="right" fixed="right" width="160">
              <template slot-scope="scope">
                
                <a class="txt-color" @click="editContent(scope.row)">编辑 </a>
                <a v-show="scope.row.bizState=='1'" class="txt-color" @click="changeState('2',scope.row.guid)">下架</a>
                <a v-show="scope.row.bizState=='2'" class="txt-color" @click="changeState('1',scope.row.guid)">上架</a>
                <a style="padding-left: 5px;" class="txt-color" @click="delContent(scope.row.guid)"> 删除 </a>
                <a class="txt-color" @click="readConfig(scope.row,1)">阅读情况 </a>
                
              </template>
            </el-table-column>
          </el-table>
          <el-pagination class="pt pb back-color-fff" background @size-change="handleSizeChange"
          @current-change="handleCurrentChange" 
          :page-sizes="[10,20,50,100, 200]"
          :current-page="page.pageIndex"
          :page-size="page.pageSize" 
          layout="total, sizes, prev, pager, next, jumper" 
          :total="page.totalRows">
        </el-pagination>
        </div>
      </div>
      <div v-show="tabIndex==1" class="right-content-box">
        <div class="search-area">

          <el-row :gutter="24">
            
            <el-col :span="6">
              <div class="search-area-div">关键字</div>
              <el-input size="mini" v-model="keywordSearch" placeholder="请输入" class="ipt-sty" />
            </el-col>
            <el-col :span="6">
              <div class="search-area-div">上架状态</div>
              <el-select size="mini" v-model="bizState" placeholder="请选择" class="ipt-sty">
                <el-option v-for="item in status" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="6" class="search-btn-box">
              <el-button size="mini" type="info" @click="searchDict('',true)">搜索</el-button>
              <el-button size="mini" type="danger" @click="emptyDictSearch">清空</el-button>
            </el-col>
          </el-row>
        </div>
        <div class="back-color-fff content-main-box">
          <div class="button-area">
            <el-button  size="mini" type="info" @click="addPolicy">发布政策</el-button>
            <el-button  size="mini" type="info" @click="batchImport">批量导入</el-button>
            <el-button  size="mini" type="default" @click="delPolicy(multipleSelection,true)" >批量删除</el-button>
            <el-button  size="mini" type="default" @click="changeState(1,multipleSelection,true)">批量上架</el-button>
            <el-button  size="mini" type="default" @click="changeState(2,multipleSelection,true)">批量下架</el-button>
            <el-button  size="mini" type="default" @click="preview()">移动端效果预览</el-button>
            <el-button  size="mini" type="default" @click="report" v-loading.fullscreen.lock="fullscreenLoading">导出阅读明细</el-button>
            <el-button  size="mini" type="default" @click="reportPolicy" v-loading.fullscreen.lock="fullscreenLoading">导出政策</el-button>
          </div>
          <el-table :data="tableData1" stripe border :height="tableHeight" style="width: 100%" v-loading="loading"  
          tooltip-effect="light"
          @selection-change="handleSelectionChange" >
            <el-table-column type="selection" width="40" header-align="center" align="center"
              fixed="left"></el-table-column>
            <el-table-column label="序号" width="50" header-align="center" align="center" fixed="left">
              <template slot-scope="scope">
                <!-- {{ scope.$index + 1 }} -->
                {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column prop="medicinePolicyCode" label="编号" header-align="left" align="left" width="80" show-overflow-tooltip fixed="left">
              <template slot-scope="scope">{{ scope.row.medicinePolicyCode }}</template>
            </el-table-column>
            <el-table-column prop="medicinePolicyTitle" label="政策标题" header-align="left" align="left" width="200" show-overflow-tooltip fixed="left">
              <template slot-scope="scope">{{ scope.row.medicinePolicyTitle }}</template>
            </el-table-column>
            
            <el-table-column prop="policyContent" label="政策内容" header-align="left" align="left" width="150" show-overflow-tooltip >
              <template slot-scope="scope">{{ scope.row.policyContent }}</template>
            </el-table-column>
            <el-table-column prop="publishName" label="发布方" header-align="left" align="left" width="120" show-overflow-tooltip >
              <template slot-scope="scope">{{ scope.row.publishName }}</template>
            </el-table-column>
            <el-table-column prop="medicinePolicyKeyword" label="关键词"  header-align="left" align="left" width="120" show-overflow-tooltip  >
              <template slot-scope="scope">{{ scope.row.medicinePolicyKeyword}}</template>
            </el-table-column>
            <el-table-column prop="publishDate" label="政策发布日期" sortable header-align="left" align="left" width="120">
              <template slot-scope="scope">{{ scope.row.publishDate | getDate }}</template>
            </el-table-column>
            <el-table-column prop="readUserNum"  label="阅读人数" header-align="left" align="right" >
              <template slot-scope="scope">{{scope.row.readUserNum | "-"}}</template>
            </el-table-column>

            <el-table-column prop=" readNum" label="阅读次数" header-align="left" align="right" >
              <template slot-scope="scope">{{ scope.row.readNum  }}</template>
            </el-table-column>
            <el-table-column prop="bizState" label="状态"  header-align="center" align="center" >
              <template slot-scope="scope">
                
                <span v-show="scope.row.bizState=='1'" class="state-class">上架</span>
                <span v-show="scope.row.bizState=='2'" class="state-class-grey">下架</span>
                
                
              </template>
            </el-table-column>
            <el-table-column prop="updateUserName" label="操作人"  header-align="left" align="left" >
              <template slot-scope="scope">{{ scope.row.updateUserName }}</template>
            </el-table-column>
            <el-table-column prop="updateTime" sortable label="操作时间" header-align="left" align="left" width="150">
              <template slot-scope="scope">{{ scope.row.updateTime | getTimeDate }}</template>
            </el-table-column>
            <el-table-column label="操作" header-align="center" align="right" fixed="right" width="160">
              <template slot-scope="scope">
                <a class="txt-color" @click="editPolicy(scope.row)">编辑 </a>
                <a v-show="scope.row.bizState=='1'" class="txt-color" @click="changeState('2',scope.row.guid)">下架</a>
                <a v-show="scope.row.bizState=='2'" class="txt-color" @click="changeState('1',scope.row.guid)">上架</a>
                <a style="padding-left: 5px;" class="txt-color" @click="delPolicy(scope.row.guid)"> 删除 </a>
                <a class="txt-color" @click="readConfig(scope.row,2)">阅读情况 </a>
                
              </template>
            </el-table-column>
          </el-table>
          <el-pagination class="pt pb back-color-fff" background @size-change="handleSizeChange"
          @current-change="handleCurrentChange" 
          :page-sizes="[10,20,50,100, 200]"
          :current-page="page.pageIndex"
          :page-size="page.pageSize" 
          layout="total, sizes, prev, pager, next, jumper" 
          :total="page.totalRows">
        </el-pagination>
        </div>
      </div>
    </div>
    <!-- start of dialog-左侧医药词典添加分类-新增|编辑 -->
    <div v-if="tabIndex==0">
      <el-dialog :title="isAdd ? '新增分类' : '编辑分类'" :visible.sync="editDialog" width="500px">
      <el-form
        ref="formData"
        label-width="80px" 
        :model="formData"
        :rules="formRules"
      >
        <!-- 分类名称 -->
        <el-form-item label="分类名称" prop="categoryName" >
          <el-input size="small" :maxlength="6"  v-model="formData.categoryName" placeholder="最多输入6个字" clearable />
        </el-form-item>
        <!-- 界面排序 -->
        <el-form-item v-if="!isAdd" label="界面排序" prop="orderNum" style="margin-bottom:0;" >
          <el-input size="small"  v-model="formData.orderNum" placeholder="请输入" clearable @input="formData.orderNum = formData.orderNum.replace(/[^\d\-\d]/g, '')"/>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" plain @click="editDialog = false">取 消</el-button>
        <el-button size="mini" type="info" @click="submitContentCategory(1)">确 定</el-button>
      </span>
    </el-dialog>
    </div>
   
    <!-- end of dialog-左侧医药词典添加分类-新增|编辑 -->
    <!-- start of dialog-左侧医药政策添加分类-新增|编辑 -->
    <div v-if="!iconVisible && tabIndex==1" id="template-config">
      <el-dialog :title="isAdd ? '新增分类' : '编辑分类'" :visible.sync="editPolicyDialog" width="500px">
      <el-form
        ref="formData"
        label-width="80px" 
        :model="formData"
        :rules="formRules1"
      >
        <!-- 分类名称 -->
        <el-form-item label="分类名称" prop="categoryName" >
          <el-input size="small" :maxlength="6"  v-model="formData.categoryName" placeholder="最多输入6个字" clearable />
        </el-form-item>
        <!-- 分类描述 -->
        <el-form-item label="分类描述" prop="categoryDesc" >
          <el-input size="small" :maxlength="6"  v-model="formData.categoryDesc" placeholder="最多输入6个字" clearable />
        </el-form-item>
        <!-- 界面排序 -->
        <el-form-item v-if="!isAdd" label="界面排序" prop="orderNum" style="margin-bottom:10px;" >
          <el-input size="small"  v-model="formData.orderNum" placeholder="请输入" clearable @input="formData.orderNum = formData.orderNum.replace(/[^\d\-\d]/g, '')"/>
        </el-form-item>
        <!-- 恋链首页分类图 -->
        <!-- <el-form-item label="恋链首页分类图" prop="homeCategoryUrl" style="margin-bottom:0;" >
        </el-form-item> -->
        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">任务图标 </span>
          <div class="img-close"
            v-if="formData.homeCategoryUrl && formData.homeCategoryUrl.length != 0 && formData.homeCategoryUrl[0].path">
            <img class="file-img" :src="formData.homeCategoryUrl && formData.homeCategoryUrl[0].path"
              alt="" srcset="" />
            <img class="close" @click="delPic" src="@/assets/images/ic_close.png" alt="" />
          </div>
          <div v-else class="icon-add" @click="addPic"><i class="el-icon-plus"></i></div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" plain @click="editPolicyDialog = false">取 消</el-button>
        <el-button size="mini" type="info" @click="submitContentCategory()">确 定</el-button>
      </span>
      </el-dialog>
    </div>
    <!-- end of dialog-左侧医药政策添加分类-新增|编辑 -->
    <!-- start of dialog-恋链首页分类图选择 -->
    <el-dialog title="选择图片" class="icon-dialog-wrap" :visible.sync="iconVisible" width="50%">
      <div class="search-area">
        <el-row :gutter="24">
          <el-col :span="12">
            <div class="search-area-div">图标名称</div>
            <el-input size="mini" v-model="paramValue" placeholder="请输入" class="ipt-sty" />
          </el-col>
          
          <el-col :span="6" class="search-btn-box">
            <el-button size="mini" type="info" @click="getIconList()">搜索</el-button>
            <el-button size="mini" type="danger" @click="emptySearch">清空</el-button>
          </el-col>
        </el-row>
      </div>
      <div class="icon-dialog">
        <div class="icon-left">
          <div class="item" :style="activeIcon == index ? 'background:#EDEDED;' : ''" @click="handleClickMenu(index)"
            v-for="(item, index) in iconList" :key="index">
            <el-tooltip :content="item.paramName" placement="right" effect="light">
              <span>
                {{ item.paramName }}
              </span>
            </el-tooltip>
          </div>
        </div>
        <div class="icon-right">
          <div class="pic" v-for="(item, index) in iconList[activeIcon] &&
          iconList[activeIcon].paramValue &&
          JSON.parse(iconList[activeIcon].paramValue)" :key="index">
            <div class="img-wrap" @click="chooseIcon(item.url,item.name)">
              <el-image class="img" :src="item.url" fit="contain" />
              <img :style="chooseURL == item.url ? 'display:block' : 'display:none;'" class="border-img"
                src="@/assets/images/ic_select.png" alt="" />
              <div class="name">{{ item.name }}</div>
            </div>
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button size="medium" type="info" @click="moreSureIcon">确 定</el-button>
      </span>
    </el-dialog>
    <!-- end of dialog-恋链首页分类图选择 -->
    <!-- start of dialog-阅读情况 -->
    <el-dialog title="阅读情况" top="5vh" custom-class="configure-fields" :visible.sync="readDialog">
      <div class="search-area">
        <el-row :gutter="24">
          <el-col :span="8">
            <div class="search-area-div">阅读人</div>
            <el-input size="mini" v-model="page3.readUserName" placeholder="请输入" class="ipt-sty" />
          </el-col>
          
          <el-col :span="6" class="search-btn-box">
            <el-button size="mini" type="info" @click="getReadInfo()">搜索</el-button>
            <el-button size="mini" type="danger" @click="emptyReadSearch">清空</el-button>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="24" class="read-title">
            内容标题：{{ readTitle }}
          </el-col>
        </el-row>
        
      </div>
      <el-table :data="readList" style="width: 100%; margin-top: 15px" border v-loading="loading">
            <!-- <el-table-column type="selection" width="60" header-align="center" align="center"></el-table-column> -->
            <el-table-column label="序号" width="60" header-align="center" align="center">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column prop="readUserName" label="阅读人" header-align="center" align="center"> </el-table-column>
            <el-table-column prop="readBeginTime" label="阅读开始时间" header-align="center" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.readBeginTime | getTimeDate }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="readEndTime" label="阅读结束时间" header-align="center" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.readEndTime | getTimeDate }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="readTime" label="阅读时长" header-align="center" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.readTime | timeFilter }}</span>
              </template>
            </el-table-column>
            
      </el-table>
      <el-pagination
          :current-page="page3.pageIndex"
          :page-size="page3.pageSize"
          layout="prev, pager, next"
          @size-change="handleSizeChange3"
          @current-change="handleCurrentChange3"
          :total="page3.totalRows"
        >
      </el-pagination>
      <span slot="footer" class="dialog-footer">
          <!-- <el-button size="mini" plain @click="readDialog = false">取 消</el-button> -->
          <el-button size="mini" type="info" @click="readDialog = false" >确 定</el-button>
        </span>
    </el-dialog>
    <!-- end of dialog-阅读情况-新增|编辑 -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableHeight: window.innerHeight - 340,
      loading: false,
      visible:false,
      keywordSearch:'',//关键字
      bizState:'',//上架状态
      policyTitle:'',
      paramValue:'',//图标名称
      categoryGuid:'',//左侧医药词典的分类
      readList:[],//阅读情况的列表
      medicineDictGuid:'',//存储阅读
      guids:[],
      readTitle:'',
      // 右边列表
      page: {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
      },
      
      // 医药词典分页
      page1: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
      },
      // 医药政策分页
      page2: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
      },
      // 阅读情况分页
      page3: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        readUserName:''
      },
      
      tagList:[
        // {
        //   categoryName: '医药词典', // 分类名称
        //   orderNum: '1' // 界面排序
        // }
      ],//标签列表
      // tagList1:[
      //   {
      //     guid: '',
      //     categoryName: '医药政策', // 分类名称
      //     categoryDesc: '政策描述', // 分类描述
      //     orderNum: '1', // 界面排序
      //     homeCategoryUrl: [] // 恋链首页分类图
      //     }

      // ],//政策标签列表
      sh:[],
      categoryName:'',//分类标签搜索
      tagflag:0,
      textTitle:'',
      gradeCategoryGuid:''	,//标签的guid
      isEdit:false,
      tenantGuid:null,
      // 状态
      status:[
      {
          value: '0',
          label: '全部',
        },
        {
          value: '1',
          label: '上架',
        },
        {
          value: '2',
          label: '下架',
        }
          
      ],
      formData:{
        guid: '',
        categoryName: '', // 分类名称
        categoryDesc: '', // 分类描述
        orderNum: null, // 界面排序
        homeCategoryUrl: [] // 恋链首页分类图
      },
      // formData1:{
      //   guid: '',
      //   categoryName: '', // 分类名称
      //   categoryDesc: '', // 分类描述
      //   orderNum: null, // 界面排序
      //   homeCategoryUrl: [] // 恋链首页分类图
      // },
      isAdd : false,
      formRules: {
        categoryName: [
          { required: true, message: '分类名称必填', trigger: 'blur' },
        ],
        // orderNum: [
        //   { required: true, message: '界面排序必填', trigger: 'blur' },
        // ]
      },
      formRules1: {
        categoryName: [
          { required: true, message: '分类名称必填', trigger: 'blur' },
        ],
        categoryDesc: [
          { required: true, message: '分类描述必填', trigger: 'blur' },
        ],
        // orderNum: [
        //   { required: true, message: '界面排序必填', trigger: 'blur' },
        // ],
       
      },
      // 弹窗
      editDialog:false,
      editPolicyDialog:false,
      readDialog:false,
      iconVisible:false,
      fullscreenLoading:false,
      tableData:[],
      tableData1:[],
      tabList: [
      { name: '医药词典'},
      
      { name: '医药政策'},
      
    ],
    tabIndex: 0,
    categoryType:1,
    iconList: [],
    activeIcon: 0,
    chooseURL: null,
    fileName:'',
    multipleSelection:[],
    };
  },
  filters:{
    
    timeFilter(val) {
      console.log('va',val);
      
        if (val&&val.length>2&&val[0]==0) {
          let str=val.slice(1)
          
          return str
        } else {
          return val||'-'
        }
      },
  },
  created() {
    
    this.getIconList();// 获取图标
    this.getContentCategory()
  },
  // beforeRouteEnter(to, from, next) {
  //   if (from.path === '/medicineSchoolAdd') {
  //     next((vm) => {
  //       vm.getContentCategory();
  //     });
  //   } else {
  //     next();
  //   }
  // },
  mounted() {
    
  },
  watch: {
    iconVisible(val){
        if(!val){
          this.paramValue=''
          this.getIconList()
        }
      }
  },
  methods: {
    /**
     * 添加左侧医药词典分类
     */
     addData() {
      this.isAdd = true;
      
      if(this.tabIndex==0){
        this.editDialog = true;
        this.formData = {
          guid: '',
          categoryName: '', // 分类名称
          // orderNum: this.page1.totalRows+1 // 界面排序
        }
      }else if(this.tabIndex==1){
        this.editPolicyDialog = true;
        this.formData = {
          guid: '',
          categoryName: '', // 分类名称
          categoryDesc: '', // 分类描述
          // orderNum: this.page1.totalRows+1 , // 界面排序
          homeCategoryUrl: [] // 恋链首页分类图
        }
      }
      
      let that = this;
      this.$nextTick(() => {
        that.$refs['formData'].clearValidate();
      })
    },
    // 修改左侧分类
    updateHandle(row){
      this.isAdd=false
      this.tabIndex==0?this.editDialog=true:this.editPolicyDialog=true
      
      this.formData=JSON.parse(JSON.stringify(row))
      
      // if(this.tabIndex==0 ||!this.formData.homeCategoryUrl){
      //   this.formData.homeCategoryUrl=[]
      //   this.$delete(this.formData,'homeCategoryUrl')
      // }else{
      //   this.formData.homeCategoryUrl=JSON.parse(this.formData.homeCategoryUrl)
      // }
      if(this.tabIndex==1){
        if(!this.formData.homeCategoryUrl){
          this.formData.homeCategoryUrl=[]
        }else{
          this.formData.homeCategoryUrl=JSON.parse(this.formData.homeCategoryUrl)
        }
        
      }
      console.log('gg', this.formData);
      let that = this;
      this.$nextTick(() => {
        that.$refs['formData'].clearValidate();
      })
    },
   
    
    //发布内容
    addContent() {
      this.$router.push({
        path: '/medicineSchoolAdd',
        query: {
          productGuid: localStorage.productGuid,
        },
      });
    },
    //编辑内容
    editContent(item) {
      this.$router.push({
        path: '/medicineSchoolAdd',
        query: {
          guid: item.guid,
          productGuid: localStorage.productGuid,
        },
      });
    },
    //发布政策
    addPolicy() {
      this.$router.push({
        path: '/medicinePolicyAdd',
        query: {
          productGuid: localStorage.productGuid,
        },
      });
    },
    //编辑政策
    editPolicy(item) {
      this.$router.push({
        path: '/medicinePolicyAdd',
        query: {
          guid: item.guid,
          productGuid: localStorage.productGuid,
        },
      });
    },
    //预览
    preview() {
      let userName = '13900000001';
      const userPwd = '666666';
      let previewUrl;
      let formUrl=`/subTaskApp/taskDistributeIndex/studyCenter?searchKey=&currentPolicyCategoryGuid=`
      previewUrl = `https://llscmtest.cs4pl.com/loginRoot?userName=${userName}&userPwd=${userPwd}&formUrl=${encodeURIComponent(formUrl)}`;
        if (location.href.indexOf('https://scm-operation-pre-test.cs4pl.com') > -1) { //uat
            userName = '13900001026';
            previewUrl = `https://fbt-pre-test.cs4pl.com/loginRoot?userName=${userName}&userPwd=${userPwd}&formUrl=${encodeURIComponent(formUrl)}`
          }
        if (location.href.indexOf('https://scm-operation.csyaoly.com') > -1) { //生产1
          userName = '13900001026';
          previewUrl = `https://llscm.csyaoly.com/loginRoot?userName=${userName}&userPwd=${userPwd}&formUrl=${encodeURIComponent(formUrl)}`
        }
        if (location.href.indexOf('https://scm-operation.cs4pl.com') > -1) { //生产2
          userName = '13900001026';
          previewUrl = `https://llscm-pre.cs4pl.com/loginRoot?userName=${userName}&userPwd=${userPwd}&formUrl=${encodeURIComponent(formUrl)}`
        }
        window.open(location.origin + '/previewPage?previewUrl=' + encodeURIComponent(previewUrl))
    },
    // 批量导入
    batchImport() {
      this.$router.push({
        path: "/importPolicyList",
        query: { 
          productGuid: localStorage.productGuid,
        },
      });
    },
    // batchImport() {
    //   this.$router.push({ path: '/importNewManagementList',query:{ productGuid:this.$route.query.productGuid,type:'0011'} });
    // },
    // 导出阅读明细
    report(){
        let that = this;
        that.fullscreenLoading = true;
        let req = {
            pageIndex: 1,
            pageSize: -1,
            keywordSearch:that.keywordSearch,
            bizState:that.bizState==0?'':that.bizState,
            categoryGuid:that.categoryGuid
          };
        let reqUrl=''
        if(this.tabIndex==0){
          reqUrl=`/${serverConfig.msProductService}/medicine-dict/export-read-info`
        }else{
          reqUrl=`/${serverConfig.msProductService}/medicine-policy/export-read-info`
        }
        that.api.postJson(reqUrl, req).then((res1) => {
          console.log('res',res1.data);
        if (res1.data.code == 'S0010') {
          // that.searchDict()
          that.$message.error(res1.data.msg);
          that.fullscreenLoading = false;
          
          
        } else {
          that.api.postJsonD(reqUrl, req).then(res => {
            
            let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            console.log('blob',blob);
            
            let str=''
            if(that.tabIndex==0){
              str='医药词典阅读明细_'
            }else{
              str='医药政策阅读明细_'
            }
            let fileName = str + this.$moment(new Date()).format('YYYYMMDD');
            let objectUrl = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.download = fileName;
            link.href = objectUrl;
            link.click();
            that.fullscreenLoading = false;
          });
        }
      });
    }, 
    // 导出政策
    reportPolicy(){
        let that = this;
        that.fullscreenLoading = true;
        let req = {
            pageIndex: 1,
            pageSize: -1,
            keywordSearch:that.keywordSearch,
            bizState:that.bizState==0?'':that.bizState,
            categoryGuid:that.categoryGuid
          };
        that.api.postJson(`/${serverConfig.msProductService}/medicine-policy/export-info`, req).then((res1) => {
          console.log('res',res1.data);
        if (res1.data.code == 'S0010') {
          // that.searchDict()
          that.$message.error(res1.data.msg);
          that.fullscreenLoading = false;
        } else {
          that.api.postJsonD(`/${serverConfig.msProductService}/medicine-policy/export-info`, req).then(res => {
            let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            console.log('blob',blob);
            let str='医药政策_'
            let fileName = str + this.$moment(new Date()).format('YYYYMMDD');
            let objectUrl = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.download = fileName;
            link.href = objectUrl;
            link.click();
            that.fullscreenLoading = false;
          });
        }
      });
    }, 
   
    // 点击查看阅读情况
    readConfig(row,flg){
      // flag=1医药词典flag=2医药政策
      this.readDialog=true
      this.page3={
          pageIndex: 1,
          pageSize: 10,
          totalPage: 0,
          totalRows: 0,
          readUserName:''
      }
      this.readTitle=(flg==1)? row.medicineDictTitle : row.medicinePolicyTitle
      this.readList=[]
      console.log('row',row);
      this.getReadInfo(row.guid)
      
      

    },
    // 点击删除内容
    delContent(guid){
      let that=this
      this.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(()=>{

        let guids=[guid]
          
        
      that.api.postJson(`/${serverConfig.msProductService}/medicine-dict/del`, guids).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          that.searchDict()
        } else {
          that.$message.error(res.data.msg);
        }
      });
      })
    },
    // 点击删除政策
    delPolicy(guid,all){
      if(!guid||guid.length<1){
        this.$message.warning('请选择需要删除的政策')
        return
      }
      let that=this
      let guids=[]
      this.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(()=>{
      if(all){
        guids=guid
      }else{
        guids=[guid]
      }
        
      that.api.postJson(`/${serverConfig.msProductService}/medicine-policy/del`, guids).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          that.searchDict()
        } else {
          that.$message.error(res.data.msg);
        }
      });
      })
    },
    // 点击上架、下架
    changeState(flg,guid,mul){
      if(!guid||guid.length<1){
        this.$message.warning('请选择需要上/下架的内容')
        return
      }
      // flg=1点击上架
      let that = this;
      let str=''
      if(flg=='1'){
        str='上架后，内容将开放给服务人员查看，确定上架吗？'
      }else{
        str='下架后，服务人员将无法看到此内容，确定下架吗？'
      }
      this.$confirm(str, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(()=>{ 
        let req={
          guids:[],
          bizState:flg
        }
        if(mul){
          req.guids=guid
        }else{
          req.guids=[guid]
        }
        let reqUrl=''
        if(this.tabIndex==0){
          reqUrl=  `/${serverConfig.msProductService}/medicine-dict/update-state`
        }else{
          reqUrl=  `/${serverConfig.msProductService}/medicine-policy/update-state`
        }
    
      
      that.api.put(reqUrl, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          that.$message.success('操作成功')
          this.searchDict()
        } else {
          that.$message.error(res.data.msg);
        }
      });
      })
    },
    //tab
    tabClick(index, item) {
      this.tabIndex = index;
      this.keywordSearch=''
      this.bizState=''
      this.categoryGuid=''
      this.page1.pageIndex=1
      this.page={
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
      
      }
      if(index==1){
        this.formData = {
          guid: '',
          categoryName: '', // 分类名称
          categoryDesc: '', // 分类描述
          // orderNum: this.page1.totalRows+1 , // 界面排序
          homeCategoryUrl: [] // 恋链首页分类图
        }
      }
      console.log('index',index);
      this.$forceUpdate()
      this.categoryType=index + 1
      this.$set(this,'tagList',[])
      // this.getData(true);
      
      // 获取内容，获取表单
      this.getContentCategory()
      this.$forceUpdate()
      
    },
    // 首页分类图
    delPic() {
      this.formData.homeCategoryUrl =[];
      this.$forceUpdate();
    },
    addPic() {
      if (this.formData.homeCategoryUrl&&this.formData.homeCategoryUrl.length!=0) {
        this.$message.error('任务图标只能选择一个');
        return;
      }
      this.iconVisible = true;
    },
    //获取图标数据
    getIconList() {
      let that = this;
      let req = {
        pageIndex: 1,
        pageSize: -1,
        totalPage: 0,
        totalRows: 0,
        bizType: '图标管理',
        paramName: '',
        paramValue:that.paramValue
        // tenantGuid: localStorage.guid,
        // tenantName: JSON.parse(localStorage.userInfo).tenantName,
      };
      that.api.postJson(`/${serverConfig.msSalesPerformService}/biz-param/data/get-list`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          that.iconList = res.data.data.records;
          that.activeIcon = 0;
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    emptySearch(){
      this.paramValue=''
      this.getIconList()
    },
    handleClickMenu(index) {
      this.activeIcon = index;
    },
    chooseIcon(url,name) {
      this.chooseURL = url;
      this.fileName=name
    },
    moreSureIcon() {
      if (!this.chooseURL) {
        this.$message.error('请选择任务图标');
        return;
      }
      this.formData.homeCategoryUrl = [
        {
          fileName: this.fileName,
          path: this.chooseURL,
        },
      ];
      this.iconVisible = false;
      this.$forceUpdate();
    },
    emptyDictSearch(){
      this.page={
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
       }
      
      this.keywordSearch=''
      this.bizState=''
      this.searchDict()
    },
    emptyReadSearch(){
      this.page3={
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        readUserName:''
       }
      if(this.tabIndex==0){
        this.getReadInfo(this.medicineDictGuid)
      }else{
        this.getReadInfo(this.medicinePolicyGuid)
      }
      
    },
    // 分页获取阅读信息
    getReadInfo(guid){
      let that=this
      
      let req = {
        pageIndex: guid?that.page3.pageIndex:1,
        pageSize:that.page3.pageSize,
        readUserName:that.page3.readUserName
      };
      let reqUrl=''
      if(this.tabIndex==0){
        this.medicineDictGuid=guid||this.medicineDictGuid
        req.medicineDictGuid=guid||this.medicineDictGuid
        reqUrl = `/${serverConfig.msProductService}/read-info/list`;
        
      }else{
        this.medicinePolicyGuid=guid||this.medicinePolicyGuid
        req.medicinePolicyGuid=guid||this.medicinePolicyGuid
        reqUrl=`/${serverConfig.msProductService}/medicine-policy-read/list`
      }
      
      this.loading = true;
      that.api.postJson(reqUrl, req).then((res) => {
        this.loading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          that.readList = res.data.data.records;
          that.page3.totalPage = res.data.data.totalPages;
          that.page3.totalRows = res.data.data.totalRows;
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    //获取医药词典列表
    searchDict(row,flg){
      let that=this
      if(row){
        console.log('rr',row);
        
        // 点击左侧分类
        if(row.guid){
          that.categoryGuid=row.guid
          
          that.page.pageIndex=1
          
        }else{
          // 点击全部
          that.categoryGuid=""
          that.$nextTick(() => {
            if(that.tagList&&that.tagList.length>0){
              that.$refs['singleTable'].setCurrentRow(that.tagList[0]);
            }
            
          })
        }
      }else{
        // 点击搜索、清空搜索
        
        if(!that.categoryGuid){
          that.$nextTick(() => {
            that.$refs['singleTable'].setCurrentRow(that.tagList[0]);
          })
        }else{
          let idx=that.tagList.findIndex(item=>{
            return item.guid==that.categoryGuid
          })
          that.$nextTick(() => {
            that.$refs['singleTable'].setCurrentRow(that.tagList[idx]);
            
            
          })
        }
        
        
      }
      console.log('row',row);
      if(flg){
        that.page.pageIndex=1
      }
      let reqUrl=''
      let req = {
          pageIndex: that.page.pageIndex,
          pageSize: that.page.pageSize,
          keywordSearch:that.keywordSearch,
          bizState:that.bizState==0?'':that.bizState,
          categoryGuid:that.categoryGuid
        };
      if(that.tabIndex==0){
        
        reqUrl=`/${serverConfig.msProductService}/medicine-dict/list-pc`
      }else{
        reqUrl=`/${serverConfig.msProductService}/medicine-policy/list-pc`
      }
      
      that.loading=true
      
      that.api.postJson(reqUrl, req).then((res) => {
        that.loading=false
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          if(this.tabIndex==0){
            that.tableData = res.data.data.records;
          }else{
            that.tableData1 = res.data.data.records;
          }
          
          that.page.totalPage = res.data.data.totalPages;
          that.page.totalRows = res.data.data.totalRows;
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 获取内容分类
    getContentCategory(){
      let that=this
      if(this.tabIndex==0){
        that.categoryType=1
      }else{
        that.categoryType=2
      }
      let req = {
        pageIndex: that.page1.pageIndex,
        pageSize: that.page1.pageSize,
        categoryName:that.categoryName,
        categoryType:that.categoryType,
      };
      that.loading = true;
      that.api.postJson(`/${serverConfig.msProductService}/content-category/list`, req).then((res) => {
        that.loading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          that.tagList = res.data.data.records;
          that.tagList.unshift({categoryName : "全部分类"})
          that.page1.totalPage = res.data.data.totalPages;
          that.page1.totalRows = res.data.data.totalRows;
          that.searchDict()
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 获取内容分类详情
    getCategoryDetail(){

    },
    // 提交内容分类
    submitContentCategory(){
      
      let that=this
      // let str=''
      // str=this.tabIndex==0?'formData':'formData1'
      // let homeCategoryUrl=that.formData.homeCategoryUrl
      let req = {
        categoryType:that.categoryType,
        ...that.formData,
        // homeCategoryUrl
      };
      
      that.$refs.formData.validate((valid) => {
        if (valid) {
          // 任务图标必填
          if (this.tabIndex==1 && this.formData.homeCategoryUrl && this.formData.homeCategoryUrl.length<1) {
            this.$message.error('请上传任务图标');
            return;
          }
          this.loading=true
          if(that.formData.guid){
        
          // 有guid为修改
          that.api.put(`/${serverConfig.msProductService}/content-category/update`, req).then((res) => {
            that.loading = false;
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              this.getContentCategory()
              this.editDialog = false;
              this.editPolicyDialog=false
              this.isAdd=false
            } else {
              that.$message.error(res.data.msg);
            }
        });
      }else{
        that.api.postJson(`/${serverConfig.msProductService}/content-category/add`, req).then((res) => {
          that.loading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          that.tagList = res.data.data.records;
          this.getContentCategory()
          this.editDialog = false;
          this.editPolicyDialog=false
          this.isAdd=false
        } else {
          that.$message.error(res.data.msg);
        }
      });
      }
        }else {
          console.log('error submit!!');
          return false;
        }
      });
      
      
      
     
    },
    // 删除内容分类
    delContentCategory(guid){
      let that=this
      that.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
          that.loading = true;
          // tenant/data/delete
          that.api.postJson(`/${serverConfig.msProductService}/content-category/del/${guid}/${that.categoryType}`).then((res) => {
            that.loading = false;
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              that.$message.success('删除成功');
              that.categoryGuid=''
              this.getContentCategory()
            } else {
              that.$message.error(res.data.msg);
            }
          });
        
          
        
      });
    },
    // 右边列表的多选
    handleSelectionChange(val){
      this.multipleSelection = [];
      
      val.forEach((item)=>{
        this.multipleSelection.push(item.guid)
      })
      console.log('vv',this.multipleSelection);
    },
   
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.searchDict()
      // if(this.tabIndex==0){
      //   this.searchDict()//获取医药词典内容
      // }else{
      //   this.searchPolicy()//获取医药政策内容
      // }
      
    },
    handleCurrentChange(val) {
      this.page.pageIndex = val;
      this.searchDict()
      // if(this.tabIndex==0){
      //   this.searchDict()//获取医药词典内容
      // }else{
      //   this.searchPolicy()//获取医药政策内容
      // }
    },
   
    handleSizeChange1(val) {
      this.page1.pageSize = val;
      this.getContentCategory()//获取内容分类
    },
    handleCurrentChange1(val) {
      this.page1.pageIndex = val;
      this.getContentCategory()//获取内容分类
    },
    // handleSizeChange2(val) {
    //   let that = this;
    //   that.page2.pageSize = val;
    //   this.searchPolicyType()//获取医药政策分类
    // },
    // handleCurrentChange2(val) {
    //   let that = this;
    //   that.page2.pageIndex = val;
    //   this.searchPolicyType()//获取医药政策分类
    // },
    handleSizeChange3(val) {
      this.page3.pageSize = val;
      if(this.tabIndex==0){
        this.getReadInfo(this.medicineDictGuid)//获取阅读情况
      }else{
        this.getReadInfo(this.medicinePolicyGuid)//获取阅读情况
      }
      
    },
    handleCurrentChange3(val) {
      this.page3.pageIndex = val;
      
      if(this.tabIndex==0){
        this.getReadInfo(this.medicineDictGuid)//获取阅读情况
      }else{
        this.getReadInfo(this.medicinePolicyGuid)//获取阅读情况
      }
    },
  },
};
</script>
<style lang="less" scoped>
.import_new_wrap{
  padding: 0;
}
.read-title{
  text-align: left;
  margin: 6px 0px -10px 7px;
}
.state-class{
  height: 22px;
  box-sizing: border-box;
  background: #F2FFF5;
  border: 1px solid rgba(220,250,228,1);
  border-radius: 2px;
  font-size: 12px;
  color: #1BA854;
  letter-spacing: 0;
  line-height: 18px;
  padding:4px

  }
.state-class-grey{
  height: 22px;
  box-sizing: border-box;
  background:  #F5F5F5;
  border: 1px solid rgba(217,217,217,1);
  border-radius: 2px;
  font-size: 12px;
  color: #404040;
  letter-spacing: 0;
  line-height: 18px;
  padding:4px
  
  }
.all-classify{
  padding-left: 20px;
  text-align: center;
  width: 50%;
  padding: 12px 0;
}
.color-grey{
  background: #ecf5ff;
}
.left-content {
  width: 20%;
  height: 100%;
  padding: 20px;
  margin-right: 10px;
  background: #fff;
  border-radius: 4px;
}
.right-content {
  flex: 1;
  overflow: hidden;
}
.el-col-5 {
  width: 33%;
  margin-bottom: 15px;
}
.el-col-4 {
  width: 33%;
}
.payment-information {
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: 30px;
  border: 1px solid #d2d2d3;
  border-radius: 4px;
  padding: 20px;
}
.pay-item {
  display: flex;
  width: 90%;
  margin-top: 10px;
  margin-bottom: 10px;
}
.pay-name {
  width: 100px;
  line-height: 32px;
  text-align: right;
  flex-shrink: 0;
  margin-right: 10px;
}
.pay-left {
  width: 100%;
}
.pay-right {
  width: 10%;
  /* flex-shrink: 0; */
}
.i-edit-sty {
  font-size: 20px;
  margin-right: 8px;
}
.i-sty {
  font-size: 20px;
}
.btn {
  display: none;
}
.btn i {
  cursor: pointer;
}
.el-table__body tr:hover .btn {
  display: block;
}
/deep/.el-pagination {
  overflow-x: auto;
}
/deep/.el-tabs__header {
  margin: 0;
}
/deep/ .el-tabs--card > .el-tabs__header .el-tabs__nav {
  // border: 0 none;
}
/deep/ .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  // border: 0 none;
}
/deep/ .el-tabs--card > .el-tabs__header .el-tabs__item {
  // border: 0 none;
}
/deep/ .el-tabs__nav-next {
  font-size: 20px;
}
/deep/.el-tabs__nav-prev {
  font-size: 20px;
}
/deep/.el-tabs__new-tab {
  margin-right: 16px;
}
.top {
  background: #fff;
  margin-bottom: 16px;
}
 .el-table /deep/ .el-input__inner {
 height: 30px;
 line-height: 40px;
}

.el-range-editor.el-input__inner {
 padding: 0px;
}

/deep/ .el-checkbox__label {
 display: none;
}

.attach-sty {
 width: 170px;
 float: left;
 margin-top: 15px;
 text-align: center;
}

.checkbox-img-sty {
 border: 1px solid #dcdfe6;
 width: 16px;
 height: 16px;
 border-radius: 2px;
 cursor: pointer;
}

/deep/ .el-step__icon.is-text {
 border-radius: 50%;
 border-color: #4fa1a4;
 border-color: inherit;
}

/deep/ .el-step__icon-inner {
 color: #4fa1a4;
}

/deep/ .el-step__title.is-process {
 color: #4fa1a4;
}

// .content {
//   background: #fff;
//   font-size: 18px;
// }

.title {
 text-align: left;
 font-size: 16px;
 font-weight: 600;
 display: flex;
 align-items: center;
 margin-bottom: 10px;
}

.title span {
 width: 6px;
 height: 14px;
 background: #4fa1a4;
 display: inline-block;
 margin-right: 10px;
}

.base {
 background: #fff;
 padding: 10px 0;
}

.content h1 {
 margin: 4px 0px;
}

.base-content {
 display: flex;
 font-size: 15px;
 padding: 7px 0;
}

.base-content .base-info {
 display: flex;
 align-items: center;
 padding: 0 40px;
}

.base-content .base-info .base-title {
 word-break: keep-all;
}

.button-area {
 display: flex;
 justify-content: flex-start;
 padding: 0px 20px 10px 10px;
 margin-top: 0;
}

/deep/.el-checkbox__label {
 display: block;
}

.checkbox-show {
 display: flex;
 margin-bottom: 10px;
}
.field-show {
 display: flex;
 align-items: center;
 height: 40px;
 padding-left: 10px;
}

.product {
 display: flex;
 align-items: center;
}

.product-img {
 width: 60px;
 height: 40px;
 margin-right: 15px;
}

.product-text {
 width: 130px;
 overflow: hidden;
 text-overflow: ellipsis;
 white-space: nowrap;
}

 .el-col-5 {
   width: 33%;
 }
 
 .ipt-sty {
   width: 69% !important;
 }
 .add-btn{
   width: 80%;
   height:28px;
   line-height: 28px;
   margin: 8px 0px;
   padding: 0;
 }
 .flex{
   width: 80%;
   margin: auto;
   display: flex;
   justify-content: space-between;
 }
 .flex1{
   display: flex;
   flex-direction: column;
   justify-content: space-between;
 }
 
 .checkTag{
   background-color:rgb(242, 242, 242) ;
 }
 .btn {
 display: none;
}
.btn a {
 cursor: pointer;
}
 .el-table__body tr:hover .btn {
 display: block;
}

 /deep/.el-tree-node__label {
   width: 80%;
   white-space: normal;
   overflow: hidden;
   text-align: left;
 }
 
 .el-tree-node__content {
   height: auto;
 }
 
 .radio-ora {
   margin-right: 12px;
 }
 
 .staff-type {
   display: inline-block;
   width: 72px;
   height: 28px;
   line-height: 28px;
   color: #4FA1A4;
   background: rgba(234, 248, 248, 0.39);
   border-radius: 2px;
 }
 
 .staff-type-biz {
   display: inline-block;
   width: 52px;
   height: 28px;
   line-height: 28px;
   color: #4FA1A4;
   background: rgba(234, 248, 248, 0.39);
   border-radius: 2px;
 }
 
 .staff-wrap {
   color: #D8814B;
   background: rgba(255, 238, 224, 0.39);
 }
 
 .biz-state {
   display: inline-block;
   width: 48px;
   height: 21px;
   line-height: 21px;
   background: rgba(239, 239, 239, 0.38);
   border-radius: 11px;
   margin-left: 5px;
 }
 
 .select-node {
   margin: 0 0 17px 0;
   text-align: left;
   font-size: 18px;
   color: #323233;
 }
 
 .custom-tree-node {
   display: inline-flex;
   overflow: hidden;
 }
 
 .content-main-box {
  
   overflow-y: visible;
 }
 
 .el-col-6{
    display: flex;
  }
  .ipt-sty{
    flex:1;
  }
  .search-area-div{
    flex-shrink: 0;
    margin-right: 4px;
    text-align:right
  }
 /* .el-pagination {
   width: calc(100% - 260px - 231px);
 } */
 .icon-dialog {
  display: flex;
  overflow: hidden;
}

.icon-dialog .icon-left {
  width: 180px;
  text-align: left;
  border-right: 1px solid #cccc;
}

.icon-left .item {
  height: 40px;
  line-height: 40px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
  padding: 0 20px;
}

.icon-dialog .icon-right {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  height: auto;
  padding-left: 10px;
}

.icon-right .pic {
  width: 100px;
  height: 130px;
  margin-right: 10px;
  margin-bottom: 10px;
}

.icon-right .pic .img {
  width: 100px;
  height: 100px;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.06);
}

.icon-right .pic .img:hover {
  border: 1px solid #4fa1a4;
  border-radius: 4px;
}

.img-wrap {
  position: relative;
}

.img-wrap .border-img {
  position: absolute;
  width: 100px;
  height: 100px;
  left: 0;
  top: 0;
}

.img-wrap .name {
  width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.file-img {
  width: 100%;
  height: 100%;
}

.icon-add {
  float: left;
  margin-left: 10px;
  width: 150px;
  height: 150px;
  border: 1px dotted #ccc;
  text-align: center;
  line-height: 150px;
}

.img-close {
  position: relative;
  float: left;
  width: 150px;
  height: 150px;
  margin-left: 20px;
}

.close {
  position: absolute;
  right: 0;
  top: 0;
  width: 20px;
  height: 20px;
}
</style>
<style>

.icon-dialog-wrap .el-dialog__body {
  padding: 0;
  padding-top: 10px;
}
#template-config .el-dialog {
    /* height: 80vh; */
    overflow: auto;
}
#template-config .el-form-item__content{
  margin-left:15px !important;
  display: flex;
}
#template-config .el-form-item{
  align-items:flex-start;
}
#template-config .calc-type .el-form-item__label{
  line-height:15px;
}
.el-table .cell{
  white-space: nowrap;
}
  .el-input__inner{
    padding: 0 8px;
  }
  .detail-class .el-table__row{
    height: 12px;
    line-height: 12px;
  }
  .el-collapse-item__header {
    padding-left: 15px;
  }
  
  .el-upload--picture-card {
    float: left;
    margin-right: 10px;
  }
  
  .circle-closesty {
    position: relative;
    top: -35px;
    margin-left: 112px;
    font-size: 20px;
    cursor: pointer;
  }
  
  .v-modal {
    z-index: 100 !important;
  }
  
  .select-box {
    overflow: hidden;
    margin: 0 0px 10px 30px;
  }
  
  .box-left {
    width: 40%;
    height: 350px;
    padding: 0 20px 20px 20px;
    border: 1px solid #bbb;
    box-sizing: border-box;
    overflow-y: auto;
  }
  
  .box-right {
    width: 57%;
    height: 350px;
    padding: 0 10px 20px 20px;
    border: 1px solid #bbb;
    box-sizing: border-box;
  }
  
  .field-radio {
    display: flex;
    align-items: center;
  }
  
  .field-radio .el-form-item__content {
    margin-left: 0 !important;
  }
  .el-form-item {
    margin-bottom: 18px;
  }
  
  .other-config {
    display: flex;
    font-size: 14px;
    padding-left: 50px;
    /* padding-top: 30px; */
  }
  
  .other-content {
    flex: 1;
  }
  
  .other-content-list {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }
  
  .other-title {
    padding-right: 10px;
  }
  
  /* 报货配置 */
  .bh-config-box {
    display: flex;
    height: 40px;
    align-items: center;
    font-size: 14px;
    padding-left: 50px;
    padding-top: 10px;
  }
  
  .bh-config-title {
    margin-right: 10px;
  }
  
  /* 库存信息采集 */
  .kc-label {
    font-size: 12px;
    color: #86909c;
  }
  
  .kc-label span {
    color: #4fa1a4;
    cursor: pointer;
  }
  
  .kc-box {
    padding: 16px;
    box-sizing: border-box;
  }
  
  .kc-box .el-tabs--border-card > .el-tabs__header .el-tabs__item {
    color: #323232;
  }
  
  .kc-box .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
    color: #323232;
  }
  .el-tabs__item.is-active{
    color: #4fa1a4;
  }
  .kc-box .el-tabs__item {
    border-right: 1px solid #dcdfe6 !important;
  }
  
  .kc-tab-box {
    height: 340px;
    padding: 0 0 40px;
    font-size: 14px;
    overflow-y: auto;
    box-sizing: border-box;
  }
  
  .kc-tab-list {
    padding: 0 0 40px 0;
    box-sizing: border-box;
    border-bottom: 1px solid #dcdcdc;
  }
  
  .kc-tab-list:last-child {
    padding-bottom: 0;
    border-bottom: none;
  }
  
  .kc-tab-label {
    display: flex;
    margin-top: 30px;
  }
  
  .label-left-name img {
    width: 16px;
    height: 16px;
    margin-right: 10px;
  }
  
  .tab-label-left {
    width: 350px;
    display: flex;
    margin-right: 20px;
  }
  
  .label-left-name {
    width: 100px;
    display: flex;
    align-items: center;
    flex-direction: row-reverse;
    flex-shrink: 0;
  }
  
  .tab-label-right {
    display: flex;
    align-items: center;
    color: #c8c8c8;
  }
  
  .tab-label-add {
    color: #4fa1a4;
    cursor: pointer;
    margin-right: 10px;
  }
  
  .tab-label-del {
    color: #d0021b;
    cursor: pointer;
    margin: 0 10px;
  }
  
  .kc-tab-rules {
    display: flex;
    margin-top: 16px;
  }
  
  .kc-rules-center {
    display: flex;
    align-items: center;
  }
  
  .rules-center-input span {
    margin: 0 8px;
  }
  
  .kc-no-label {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .kc-no-label img {
    width: 213px;
    margin-right: 35px;
  }
  
  .no-label-text {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  
  .no-label-text h3 {
    font-size: 18px;
    color: #7f828f;
    text-align: left;
    font-weight: 500;
    margin: 0;
  }
  
  .no-label-text p {
    font-size: 14px;
    color: #7f828f;
    line-height: 20px;
    margin: 6px 0 13px;
    text-align: left;
  }
  
  .no-label-btn {
    width: 120px;
    height: 40px;
    line-height: 40px;
    border-radius: 2px;
    text-align: center;
    color: #4fa1a4;
    cursor: pointer;
    border: 1px solid #4fa1a4;
  }
  
  .dy-table {
    width: 800px;
    margin-left: 10px;
  }
  
  .dy-table .dy-table-title {
    display: flex;
    height: 60px;
    line-height: 60px;
    background: #f2f2f2;
    border-bottom: 1px solid #ddd;
  }
  
  .dy-table .dy-table-title div {
    width: 200px;
  }
  
  .dy-table .dy-table-item {
    display: flex;
    height: 50px;
    align-items: center;
    border-bottom: 1px solid #ddd;
  }
  
  .dy-table-item-label {
    width: 200px;
    flex-shrink: 0;
    text-align: center;
  }
  
  .dy-table .dy-radio-box {
    width: 200px !important;
    text-align: center;
  }
  
  .dy-config-wrap {
    display: flex;
    font-size: 14px;
    margin: 30px 0;
    padding-left: 50px;
  }
  
  .dy-config-title {
    flex-shrink: 0;
    margin-top: 20px;
  }
  
  .product-select-all {
    margin-bottom: 20px;
  }
  .title-content {
    margin-top: 10px;
    margin-bottom: 10px;
    display: flex;
    width: 100%;
  }
  .title-item {
    vertical-align: middle;
    text-align: center;
    padding-right: 10px;
  }
  .left-text {
    text-align: left;
  }
  .w200 {
    width: 30%;
  }
  .w160 {
    width: 160px;
  }
  .w240 {
    width: 200px;
  }
  .w100 {
    width: 100px;
  }
  .configure-fields {
    width: 760px !important;
  }
  .configure-fields .el-dialog__body {
    overflow-y: auto;
    max-height: 600px;
  }
  .el-dialog__footer {
    border-top: 1px solid #d9d9d9;
  }
  .el-dialog__header {
    border-bottom: 1px solid #d9d9d9;
  }
  /* 选项内容样式 */
  .select-content-box {
    width: 92%;
    margin: 0 0px 10px 30px;
  }
  .select-content {
    width: 100%;
    /* padding:0 10px; */
    background: #fafafa;
    border: 1px solid #e5e5e5;
  }
  .el-form-item__label {
    color: #666;
  }
  .select-content .el-form-item__label {
    width: 90px !important;
  }
  .select-content .el-form-item__content {
    margin-left: 90px !important;
  }
  .config-item .el-form-item__content {
    margin-left: 0px !important;
  }
  /*  */
  .max-value {
    position: relative;
    height: 40px;
  }
  .max-value .el-input-number--mini {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 104px;
  }
</style>

